import $ from 'jquery'

let $window = $(window)

export default () => {
    $('img').toArray().forEach((el) => {
        let image = new Image()
        image.onload = onImageEvent
        image.onerror = onImageEvent
        image.src = el.src
    })
}

function onImageEvent (e) {
    let complete = true

    $('img').toArray().forEach((el) => {
        if (!el.complete) {
            complete = false
        }
    })

    $window.trigger('imageLoaded', [e, complete])

    if (complete) {
        $window.trigger('imagesLoaded')
    }
}
